// extracted by mini-css-extract-plugin
export var contentBody = "_cc-9";
export var headerImage = "_cc-2";
export var imageButton = "_cc-7";
export var imageButtonIcon = "_cc-8";
export var imageHeader = "_cc-4";
export var imageHeaderText = "_cc-5";
export var imageOverlay = "_cc-3";
export var imageTitle = "_cc-6";
export var imageWrapper = "_cc-1";
export var taskList = "_cc-a";
export var widget = "_cc-0";